// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "specialist-260611-25/static/css/" + chunkId + "." + {"191":"2e9f5428","200":"4f7b3521","864":"f2764e67"}[chunkId] + ".chunk.css";
};